import { graphql, Link, useStaticQuery } from "gatsby"
import React from "react"
import { Button, Container } from "react-bootstrap"

const query = graphql`
  {
    allStrapiBlogs(
      limit: 1
      sort: { fields: published_at, order: DESC }
      filter: { isFeatured: { eq: true } }
    ) {
      nodes {
        id
        slug
        title
        shortDescription
        category
        Image {
          localFile {
            publicURL
          }
        }
      }
    }
  }
`
const BannerBlog = () => {
  const data = useStaticQuery(query)
  const {
    allStrapiBlogs: { nodes: bannerBlog },
  } = data

  const {
    shortDescription,
    title,
    category,
    Image: {
      localFile: { publicURL },
    },
    slug,
  } = bannerBlog[0]

  return (
    <section className="banner">
      {bannerBlog[0] ? (
        <>
          <div className="hero-img-container">
            <div className="color-overlay"></div>
            <img src={publicURL} alt={title} />
          </div>
          <Container>
            <div className="banner-det">
              <h1>Featured Posts</h1>
              <h2>{title}</h2>
              <p>{shortDescription}</p>
              <Link to={`/blog/${category}/${slug}`}>
                <Button variant="outline">Read More</Button>
              </Link>
            </div>
          </Container>
          <div className="banner-signup d-lg-flex d-block justify-content-around align-items-center mb-5 container-fluid  p-4 p-lg-3">
            <p className="text-center text-lg-start">
              Donec lacinia nisl et placerat suscipit. Maecenas vestibulum, eros
              eu auctor auctor, urna justo
            </p>
            <div className="d-grid gap-2">
              <Button variant="outline">Read More</Button>
            </div>
          </div>
        </>
      ) : (
        <h1 className="text-center">No Featured Post!</h1>
      )}
    </section>
  )
}

export default BannerBlog
